<template>
  <v-app>
    <v-app-bar
      app
      color="primary"
      dark
    >
      <div class="d-flex align-center">
       <h1>Malaysian Members of Parliament</h1>
      </div>

      <v-spacer></v-spacer>
    </v-app-bar>

    <v-main>
      <HelloWorld/>
    </v-main>

    <v-footer
    color="primary lighten-1"
    >
      <v-row
        justify="center"
        no-gutters
      >
        <v-col>
          <p class="text-justify white--text">
            This simple website shows list of Members of Parliament in Malaysia. List is pulled from Wikipedia.
          </p>
          <p class="text-justify white--text">
            If you have any correction, suggestion or comment, feel free to reach out to me at <a class="orange--text" href="https://twitter.com/vandershraaf" target="_blank">@vandershraaf</a>
          </p>
        </v-col>
        <v-col
          class="primary lighten-2 py-4 text-center white--text"
          cols="12"
        >
          {{ new Date().getFullYear() }} — <strong>Ashraf</strong>
        </v-col>
      </v-row>
    </v-footer>
  </v-app>
</template>

<script>
import HelloWorld from './components/HelloWorld';

export default {
  name: 'App',

  components: {
    HelloWorld,
  },

  data: () => ({
    //
  }),
};
</script>
